export const blockIconsHardwareSmartDisplay = (
	<span className='material-symbols-outlined'>smart_display</span>
);
